import { withLazyLoading } from '@atlaskit/editor-common/lazy-node-view';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';
import { embedCardNodeView } from './embedCard';
export var lazyEmbedCardView = function lazyEmbedCardView(props) {
  if (editorExperiment('platform_editor_exp_lazy_node_views', false)) {
    return embedCardNodeView(props);
  }
  return withLazyLoading({
    nodeName: 'embedCard',
    getNodeViewOptions: function getNodeViewOptions() {},
    loader: function loader() {
      var result = import( /* webpackChunkName: "@atlaskit-internal_editor-plugin-embed-card-item-nodeview" */
      './embedCard').then(function (_ref) {
        var embedCardNodeView = _ref.embedCardNodeView;
        return embedCardNodeView(props);
      });
      return result;
    }
  });
};